import { gql, graphql } from "react-apollo"

const SUBSCRIBE_TO_MAILING_LIST = gql`
  mutation subscribeToMailingList($email: String!) {
    subscribeToMailingList(email: $email) {
      mailchimpId
      subscribedAt
    }
  }
`

const mutateSubscribeToMailingList = graphql(SUBSCRIBE_TO_MAILING_LIST, {
  name: "mutateSubscribeToMailingList",
  props: ({ mutateSubscribeToMailingList }) => ({
    subscribeToMailingList: ({ email }: { email: string }) =>
      mutateSubscribeToMailingList({
        variables: { email }
      })
  })
})

export default mutateSubscribeToMailingList



// WEBPACK FOOTER //
// ./src/Kiosk/queries/mutateSubscribeToMailingList.js